import { ElementRef, EventEmitter, SimpleChanges } from "@angular/core";
import { AccountService } from '../../../core/auth/account.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SessionService } from '../../session/session.service';
import { SessionControlComponent } from '../../session/session-chat-coach/session-control.component/session-control.component';
import { MessageService } from '../../message/message.service';
import { JhiAlertService, JhiEventManager } from '../../../ng-jhipster/service';
import { SessionStorageService } from "ngx-webstorage";
import { TranslateService } from "@ngx-translate/core";
import { CoachDetailsService } from '../../slot/coach-details.service';
import { Session } from '../../../shared/model/session.model';
import { DataSharingConsentService } from '../../data-sharing-consent/data-sharing-consent.service';
import { ZoomService } from '../zoom.service';
import { OrganizationResourcesComponent } from '../../organization-resources/organization-resources.component';
import { LeaveNumberModalComponent } from '../../login/leave-number-modal.component';
import { UserInteractionService } from '../../user-interaction/user-interaction.service';
import { OrganizationResourceService } from '../../../admin/organization-resource/organization-resource.service';
import { TrackerService } from '../../../core/tracker/tracker.service';
import { LANGUAGES } from '../../../app.constants';
import { UserService } from '../../../core/user/user.service';
import * as i0 from "@angular/core";
import * as i1 from "../../message/message.service";
import * as i2 from "../../../ng-jhipster/service";
import * as i3 from "ngx-webstorage";
import * as i4 from "../../session/session.service";
import * as i5 from "@ng-bootstrap/ng-bootstrap";
import * as i6 from "@ngx-translate/core";
import * as i7 from "../../../core/auth/account.service";
import * as i8 from "../../slot/coach-details.service";
import * as i9 from "../../data-sharing-consent/data-sharing-consent.service";
import * as i10 from "../zoom.service";
import * as i11 from "../../user-interaction/user-interaction.service";
import * as i12 from "../../../admin/organization-resource/organization-resource.service";
import * as i13 from "../../../core/tracker/tracker.service";
import * as i14 from "../../../core/user/user.service";
import * as i15 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i16 from "@angular/common";
import * as i17 from "@angular/material/tooltip";
import * as i18 from "@fortawesome/angular-fontawesome";
import * as i19 from "../audio-toggler/audio-toggler.component";
import * as i20 from "../video-toggler/video-toggler.component";
import * as i21 from "@ctrl/ngx-emoji-mart/ngx-emoji";
import * as i22 from "../virtual-background-selector/virtual-background-selector.component";
import * as i23 from "../../../shared/resources-for-help/resources-for-help.component";
import * as i24 from "../../../shared/language/find-flag-code-from-key.pipe";
const _c0 = ["resourcesForHelpModal"];
const _c1 = ["askToShareOrganizationResources"];
function CoachSessionControlComponent_li_17_li_15_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 57);
    i0.ɵɵlistener("click", function CoachSessionControlComponent_li_17_li_15_Template_li_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r27); const speaker_r25 = restoredCtx.$implicit; i0.ɵɵnextContext(); const _r23 = i0.ɵɵreference(3); const ctx_r26 = i0.ɵɵnextContext(); ctx_r26.selectSpeaker(speaker_r25); return _r23.close(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const speaker_r25 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", speaker_r25.label, " ");
} }
function CoachSessionControlComponent_li_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "span", 15, 54);
    i0.ɵɵelementStart(4, "a", 6);
    i0.ɵɵelementStart(5, "div", 17);
    i0.ɵɵelement(6, "span", 55);
    i0.ɵɵelementStart(7, "div", 14);
    i0.ɵɵelementStart(8, "div", 19);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(9, "svg", 20);
    i0.ɵɵelement(10, "use", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(11, "span", 22);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "fa-icon", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "ul", 56);
    i0.ɵɵtemplate(15, CoachSessionControlComponent_li_17_li_15_Template, 2, 1, "li", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const _r0 = i0.ɵɵreference(16);
    i0.ɵɵadvance(12);
    i0.ɵɵtextInterpolate(ctx_r1.selectedSpeaker == null ? null : ctx_r1.selectedSpeaker.label);
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("left", _r0.offsetWidth - 20 + "px");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.speakerList);
} }
function CoachSessionControlComponent_li_33_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 57);
    i0.ɵɵlistener("click", function CoachSessionControlComponent_li_33_Template_li_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r30); const camera_r28 = restoredCtx.$implicit; const ctx_r29 = i0.ɵɵnextContext(); const _r2 = i0.ɵɵreference(21); ctx_r29.selectCamera(camera_r28); return _r2.close(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const camera_r28 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", camera_r28.label, " ");
} }
function CoachSessionControlComponent_li_49_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 57);
    i0.ɵɵlistener("click", function CoachSessionControlComponent_li_49_Template_li_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r33); const microphone_r31 = restoredCtx.$implicit; const ctx_r32 = i0.ɵɵnextContext(); const _r4 = i0.ɵɵreference(37); ctx_r32.selectMicrophone(microphone_r31); return _r4.close(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const microphone_r31 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", microphone_r31.label, " ");
} }
function CoachSessionControlComponent_li_65_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 58);
    i0.ɵɵlistener("click", function CoachSessionControlComponent_li_65_Template_li_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r36); const language_r34 = restoredCtx.$implicit; const ctx_r35 = i0.ɵɵnextContext(); const _r6 = i0.ɵɵreference(53); ctx_r35.languageChanged(language_r34); return _r6.close(); });
    i0.ɵɵelement(1, "ngx-emoji", 59);
    i0.ɵɵpipe(2, "findFlagCodeFromKey");
    i0.ɵɵelementStart(3, "span", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const language_r34 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("emoji", "flag-", i0.ɵɵpipeBind1(2, 2, language_r34.code), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(language_r34.name);
} }
function CoachSessionControlComponent_li_66_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "span", 15, 60);
    i0.ɵɵelementStart(4, "a", 6);
    i0.ɵɵelementStart(5, "div", 17);
    i0.ɵɵelement(6, "span", 61);
    i0.ɵɵelementStart(7, "div", 14);
    i0.ɵɵelementStart(8, "div", 19);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(9, "svg", 20);
    i0.ɵɵelement(10, "use", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(11, "span", 62);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "fa-icon", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "ul", 24);
    i0.ɵɵelementStart(14, "div");
    i0.ɵɵelementStart(15, "virtual-background-selector", 63);
    i0.ɵɵlistener("virtualBackgroundSelected", function CoachSessionControlComponent_li_66_Template_virtual_background_selector_virtualBackgroundSelected_15_listener($event) { i0.ɵɵrestoreView(_r39); const _r37 = i0.ɵɵreference(3); const ctx_r38 = i0.ɵɵnextContext(); ctx_r38.selectVirtualBackground($event); return _r37.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    const _r0 = i0.ɵɵreference(16);
    i0.ɵɵadvance(11);
    i0.ɵɵpropertyInterpolate1("jhiTranslate", "sessionChat.label.virtualBackgrounds.", ctx_r8.selectedVirtualBackground, "");
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("left", _r0.offsetWidth - 20 + "px");
} }
function CoachSessionControlComponent__svg_use_72_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 64);
} }
function CoachSessionControlComponent__svg_use_73_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 65);
} }
function CoachSessionControlComponent__svg_use_79_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 66);
} }
function CoachSessionControlComponent__svg_use_80_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 67);
} }
function CoachSessionControlComponent_div_81_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(0, "div", 68);
} }
const _c2 = function (a0) { return { "dropdown-item-disabled": a0 }; };
function CoachSessionControlComponent_li_92_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 69);
    i0.ɵɵlistener("click", function CoachSessionControlComponent_li_92_Template_li_click_0_listener() { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(); return ctx_r40.displayOrganisationResourcesModal(); });
    i0.ɵɵelement(1, "span", 70);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c2, !ctx_r14.isCoachAllowedToSeeOrganizationResources));
} }
function CoachSessionControlComponent_div_98_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 72);
    i0.ɵɵlistener("click", function CoachSessionControlComponent_div_98_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r44); const ctx_r43 = i0.ɵɵnextContext(2); return ctx_r43.extendSessionByTenMinutes(); });
    i0.ɵɵelement(1, "span", 73);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r42 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("background", ctx_r42.minutesLeft > 10 || ctx_r42.session.ended ? "#7CBFAE" : "#44A38B");
} }
function CoachSessionControlComponent_div_98_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵtemplate(1, CoachSessionControlComponent_div_98_button_1_Template, 2, 2, "button", 71);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r15.session.minutesLeftToSessionStart <= 0);
} }
function CoachSessionControlComponent_div_99_Template(rf, ctx) { if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵelementStart(1, "button", 74);
    i0.ɵɵlistener("click", function CoachSessionControlComponent_div_99_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r46); const ctx_r45 = i0.ɵɵnextContext(); const _r17 = i0.ɵɵreference(104); return ctx_r45.open(_r17); });
    i0.ɵɵelement(2, "span", 75);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r16.session.ended);
} }
function CoachSessionControlComponent_ng_template_103_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 77);
    i0.ɵɵelementStart(1, "div", 78);
    i0.ɵɵelementStart(2, "fa-icon", 79);
    i0.ɵɵlistener("click", function CoachSessionControlComponent_ng_template_103_div_0_Template_fa_icon_click_2_listener() { i0.ɵɵrestoreView(_r50); const ctx_r49 = i0.ɵɵnextContext(2); return ctx_r49.dismissAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 80);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵelement(5, "h3", 81);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵelement(7, "p", 82);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 83);
    i0.ɵɵelementStart(9, "button", 84);
    i0.ɵɵlistener("click", function CoachSessionControlComponent_ng_template_103_div_0_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r50); const ctx_r51 = i0.ɵɵnextContext(2); return ctx_r51.endSession(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 85);
    i0.ɵɵlistener("click", function CoachSessionControlComponent_ng_template_103_div_0_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r50); const ctx_r52 = i0.ɵɵnextContext(2); return ctx_r52.dismissAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CoachSessionControlComponent_ng_template_103_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, CoachSessionControlComponent_ng_template_103_div_0_Template, 11, 0, "div", 76);
} if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r18.ended);
} }
function CoachSessionControlComponent_ng_template_105_Template(rf, ctx) { if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 86);
    i0.ɵɵelementStart(1, "div", 78);
    i0.ɵɵelementStart(2, "fa-icon", 87);
    i0.ɵɵlistener("click", function CoachSessionControlComponent_ng_template_105_Template_fa_icon_click_2_listener() { i0.ɵɵrestoreView(_r55); const ctx_r54 = i0.ɵɵnextContext(); return ctx_r54.dismissAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 88);
    i0.ɵɵelementStart(4, "resources-for-help", 89);
    i0.ɵɵlistener("resourceSelected", function CoachSessionControlComponent_ng_template_105_Template_resources_for_help_resourceSelected_4_listener($event) { i0.ɵɵrestoreView(_r55); const ctx_r56 = i0.ɵɵnextContext(); return ctx_r56.onResourceSelected($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("user", ctx_r20.session.user);
} }
function CoachSessionControlComponent_ng_template_107_Template(rf, ctx) { if (rf & 1) {
    const _r59 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 90);
    i0.ɵɵelementStart(1, "div", 78);
    i0.ɵɵelementStart(2, "fa-icon", 79);
    i0.ɵɵlistener("click", function CoachSessionControlComponent_ng_template_107_Template_fa_icon_click_2_listener() { i0.ɵɵrestoreView(_r59); const ctx_r58 = i0.ɵɵnextContext(); return ctx_r58.dismissAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 91);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵelement(5, "h3", 92);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "br");
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵelement(8, "p", 93);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 83);
    i0.ɵɵelementStart(10, "button", 94);
    i0.ɵɵlistener("click", function CoachSessionControlComponent_ng_template_107_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r59); const ctx_r60 = i0.ɵɵnextContext(); return ctx_r60.dismissAll(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "button", 95);
    i0.ɵɵlistener("click", function CoachSessionControlComponent_ng_template_107_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r59); const ctx_r61 = i0.ɵɵnextContext(); return ctx_r61.askToShare(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c3 = function (a0) { return { minutesLeft: a0 }; };
const _c4 = function () { return { "color": "#44A38B" }; };
const _c5 = function () { return { "color": "#E1E1E1" }; };
export class CoachSessionControlComponent extends SessionControlComponent {
    constructor(messageService, alertService, sessionStorage, sessionService, modalService, translate, accountService, coachDetailsService, dataSharingConsentService, eventManager, zoomService, userInteractionService, ngbModal, organizationResourceService, trackerService, userService) {
        super(messageService, alertService, sessionStorage, sessionService, modalService, translate, accountService, coachDetailsService, trackerService);
        this.messageService = messageService;
        this.alertService = alertService;
        this.sessionStorage = sessionStorage;
        this.sessionService = sessionService;
        this.modalService = modalService;
        this.translate = translate;
        this.accountService = accountService;
        this.coachDetailsService = coachDetailsService;
        this.dataSharingConsentService = dataSharingConsentService;
        this.eventManager = eventManager;
        this.zoomService = zoomService;
        this.userInteractionService = userInteractionService;
        this.ngbModal = ngbModal;
        this.organizationResourceService = organizationResourceService;
        this.trackerService = trackerService;
        this.userService = userService;
        this.onAudioStatusChanged = new EventEmitter();
        this.onVideoStatusChanged = new EventEmitter();
        this.displayUserPanel = new EventEmitter();
        this.onStopCall = new EventEmitter();
        this.isSettingsOn = false;
        this.isCoachAllowedToSeeOrganizationResources = false;
        this.languageList = [
            { id: 40, code: "en", name: "English", nativeName: "English", coachReasoning: "" },
            { id: 39, code: "nl", name: "Dutch", nativeName: "Nederlands", coachReasoning: "" },
            { id: 51, code: "de", name: "German", nativeName: "Deutsch", coachReasoning: "" },
        ];
        this.hover = false;
        this.below = 'below';
        this.virtualBackgroundEnabled = this.zoomService.isVirtualBackgroundEnabled();
    }
    ngOnChanges(changes) {
        if (changes.session && this.languageList) {
            this.setSelectedLanguageBasedOnSessionLanguage();
        }
    }
    ngOnInit() {
        super.ngOnInit();
        this.getAvailableSpeakersSubscription = this.zoomService.getAvailableSpeakers().subscribe(speakers => {
            this.speakerList = speakers;
        });
        this.getAvailableCamerasSubscription = this.zoomService.getAvailableCameras().subscribe(cameras => {
            this.cameraList = cameras;
        });
        this.getAvailableMicrophonesSubscription = this.zoomService.getAvailableMicrophones().subscribe(microphones => {
            this.microphoneList = microphones;
        });
        this.selectedCameraSubscription = this.zoomService.selectedCamera$().subscribe(value => {
            this.selectedCamera = value;
        });
        this.selectedSpeakerSubscription = this.zoomService.selectedSpeaker$().subscribe(value => {
            this.selectedSpeaker = value;
        });
        this.selectedMicSubscription = this.zoomService.selectedMic$().subscribe(value => {
            this.selectedMicrophone = value;
        });
        this.selectedVirtualBackgroundSubscription = this.zoomService.virtualBackground$().subscribe(value => {
            this.selectedVirtualBackground = value;
        });
        console.log(this.session);
        if (this.session != null) {
            this.coachee = this.session.user;
            this.organizationResourceService.areAnyOrganizationResourcesExistByUserIdAndLangKey(this.session.user.id, this.session.langKey).subscribe(res2 => {
                this.areAnyOrganizationResourcesExistForUser = res2.body;
                this.checkIsCoachAllowedToSeeOrganizationResources();
            });
            this.checkIsCoachAllowedToSeeOrganizationResources();
            this.userService.getCoachReasoningLanguages(this.session.coachId).subscribe(coachLanguages => {
                this.languageList = LANGUAGES.filter(lang => coachLanguages.includes(lang.code));
                this.setSelectedLanguageBasedOnSessionLanguage();
            });
        }
        else {
            console.log("Session can not be retrieved.");
        }
        this.eventManager.subscribe('userInteractionFinishedForConsentToShareOrganizationResource', () => {
            this.checkIsCoachAllowedToSeeOrganizationResources();
        });
    }
    setSelectedLanguageBasedOnSessionLanguage() {
        this.selectedLanguage = this.languageList.find(value => value.code === this.session.langKey);
    }
    checkIsCoachAllowedToSeeOrganizationResources() {
        this.dataSharingConsentService.find("ORGANIZATION_RESOURCE" /* ORGANIZATION_RESOURCE */, this.coachee.id).subscribe(dataSharingConsent => {
            if (dataSharingConsent === null || dataSharingConsent === void 0 ? void 0 : dataSharingConsent.body.consented) {
                this.isCoachAllowedToSeeOrganizationResources = true;
            }
        });
    }
    selectSpeaker(speaker) {
        this.zoomService.switchSpeaker(speaker);
    }
    selectCamera(camera) {
        this.zoomService.switchCamera(camera);
    }
    selectMicrophone(microphone) {
        this.zoomService.switchMic(microphone);
    }
    selectLanguage(language) {
        this.selectedLanguage = language;
    }
    toggleUserPanel() {
        this.displayUserPanel.emit();
    }
    toggleScript() {
        this.displayScriptComponent.emit();
    }
    stopCall() {
        this.onStopCall.emit();
    }
    sendSelfScan() {
        this.messageService.startWellbeingScan(this.session.user.id, this.session.id).subscribe(() => this.alertService.info('inukaNgApp.session.selfScanSent'), () => console.log('fail'));
    }
    displayResourcesModal() {
        this.modalService.open(this.resourcesForHelpModal, { windowClass: 'resources-for-help-modal' });
    }
    displayOrganisationResourcesModal() {
        if (this.isCoachAllowedToSeeOrganizationResources) {
            const modalRef = this.modalService.open(OrganizationResourcesComponent, { size: "lg", centered: true });
            modalRef.componentInstance.isPopup = true;
            modalRef.componentInstance.userId = this.session.user.id;
            modalRef.componentInstance.organizationResourcesModalRef = modalRef;
        }
        else {
            this.modalService.open(this.askToShareOrganizationResources, { size: "md", centered: true });
        }
    }
    askToShare() {
        this.userInteractionService.startUserInteraction("CONSENT_TO_SHARE_ORGANIZATION_RESOURCE", this.session.user.id).subscribe(res => {
            console.log(res);
            this.dismissAll();
            const modalRef = this.ngbModal.open(LeaveNumberModalComponent, { size: 'md', centered: true });
            modalRef.componentInstance.leaveNumberModalRef = modalRef;
            modalRef.componentInstance.displayNLHelpHeader = false;
            modalRef.componentInstance.errorMessage = "sessionChat.header.sent";
        });
    }
    languageChanged(language) {
        this.selectedLanguage = language;
        this.sessionService.changeSessionLanguage(this.selectedLanguage.code, this.session.id).subscribe(() => {
            this.zoomService.switchLanguage(this.selectedLanguage.code);
        });
    }
    selectVirtualBackground(virtualBackgroundType) {
        this.zoomService.changeVirtualBackground(virtualBackgroundType);
    }
    ngOnDestroy() {
        var _a, _b, _c, _d, _e, _f, _g;
        super.ngOnDestroy();
        (_a = this.getAvailableSpeakersSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.getAvailableMicrophonesSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        (_c = this.getAvailableSpeakersSubscription) === null || _c === void 0 ? void 0 : _c.unsubscribe();
        (_d = this.selectedMicSubscription) === null || _d === void 0 ? void 0 : _d.unsubscribe();
        (_e = this.selectedCameraSubscription) === null || _e === void 0 ? void 0 : _e.unsubscribe();
        (_f = this.selectedSpeakerSubscription) === null || _f === void 0 ? void 0 : _f.unsubscribe();
        (_g = this.selectedVirtualBackgroundSubscription) === null || _g === void 0 ? void 0 : _g.unsubscribe();
    }
}
CoachSessionControlComponent.ɵfac = function CoachSessionControlComponent_Factory(t) { return new (t || CoachSessionControlComponent)(i0.ɵɵdirectiveInject(i1.MessageService), i0.ɵɵdirectiveInject(i2.JhiAlertService), i0.ɵɵdirectiveInject(i3.SessionStorageService), i0.ɵɵdirectiveInject(i4.SessionService), i0.ɵɵdirectiveInject(i5.NgbModal), i0.ɵɵdirectiveInject(i6.TranslateService), i0.ɵɵdirectiveInject(i7.AccountService), i0.ɵɵdirectiveInject(i8.CoachDetailsService), i0.ɵɵdirectiveInject(i9.DataSharingConsentService), i0.ɵɵdirectiveInject(i2.JhiEventManager), i0.ɵɵdirectiveInject(i10.ZoomService), i0.ɵɵdirectiveInject(i11.UserInteractionService), i0.ɵɵdirectiveInject(i5.NgbModal), i0.ɵɵdirectiveInject(i12.OrganizationResourceService), i0.ɵɵdirectiveInject(i13.TrackerService), i0.ɵɵdirectiveInject(i14.UserService)); };
CoachSessionControlComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CoachSessionControlComponent, selectors: [["coach-session-control"]], viewQuery: function CoachSessionControlComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resourcesForHelpModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.askToShareOrganizationResources = _t.first);
    } }, inputs: { session: "session", isAudioOn: "isAudioOn", isVideoOn: "isVideoOn", showUnreadIndicator: "showUnreadIndicator", isScriptOn: "isScriptOn", isUserPanelOn: "isUserPanelOn" }, outputs: { onAudioStatusChanged: "onAudioStatusChanged", onVideoStatusChanged: "onVideoStatusChanged", displayUserPanel: "displayUserPanel", onStopCall: "onStopCall" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 109, vars: 53, consts: [[1, "navbar"], [1, "d-flex", "align-items-center"], [1, "mr-2", "text-center"], ["jhiTranslate", "sessionChat.paragraph.timeLeft", 1, "mr-1", "time-left"], ["jhiTranslate", "sessionChat.paragraph.minutesLeft", 1, "mr-1", "minutes", 3, "translateValues"], ["ngbDropdown", "", 1, "d-inline-block", "text-dark", "align-middle"], ["ngbDropdownToggle", "", "href", "javascript:void(0);", 1, "language-anchor"], [1, "box-button", "d-flex", "align-items-center", "justify-content-center", "m-1", 3, "ngStyle", "matTooltipPosition", "matTooltipClass", "matTooltip", "mouseover", "mouseleave", "click"], [1, "m-1"], ["width", "22", "height", "22"], ["id", "actual-icon", 0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#settings"], ["ngbDropdownMenu", "", 1, "dropdown-menu", "dropdown-menu-settings", "dropdown-menu-right", "dropdown-menu-location-primary"], ["primaryDropdown", ""], [4, "ngIf"], [1, "d-flex", "justify-content-between", "align-items-center"], ["ngbDropdown", "", 1, "d-inline-block", "text-dark", "align-middle", "w-100"], ["cameraDropdown", "ngbDropdown"], [1, "align-items-center", "justify-content-center", "m-1"], ["jhiTranslate", "sessionChat.coachSessionControl.selectCamera", 1, "item-bold"], [1, "d-flex", "justify-content-start", "align-items-center"], ["width", "14", "height", "14"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#tick-mark"], [1, "item-light"], ["icon", "chevron-right", 1, "ml-2"], ["ngbDropdownMenu", "", 1, "dropdown-menu", "dropdown-menu-camera", "dropdown-menu-right"], ["class", "item-light mb-2", 3, "click", 4, "ngFor", "ngForOf"], ["microphoneDropdown", "ngbDropdown"], ["jhiTranslate", "sessionChat.coachSessionControl.selectMicrophone", 1, "item-bold"], ["languageDropdown", "ngbDropdown"], ["jhiTranslate", "sessionChat.coachSessionControl.transcriptionLanguage", 1, "item-bold"], ["class", "item-light d-flex justify-content-start align-items-top", 3, "click", 4, "ngFor", "ngForOf"], [1, "box-button", "box-button-toggle", "d-flex", "align-items-center", "justify-content-center", "m-1", 3, "ngClass", "ngStyle", "matTooltipPosition", "matTooltipClass", "matTooltip", "click", "mouseover", "mouseleave"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#script-light", 4, "ngIf"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#script", 4, "ngIf"], [1, "position-relative", "m-1"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#panel-light", 4, "ngIf"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#panel", 4, "ngIf"], ["class", "unread-indicator", 4, "ngIf"], [1, "box-button", "box-button-dropdown", "d-flex", "align-items-center", "justify-content-center", "m-1"], ["icon", "ellipsis-h", 2, "font-size", "18px"], ["ngbDropdownMenu", "", 1, "dropdown-menu", "dropdown-menu-3dots", "dropdown-menu-right", "dropdown-menu-location-primary", "pb-0"], [1, "dropdown-item", "p-0", 3, "click"], ["jhiTranslate", "sessionChat.button.sendSelfScan", 1, "item-bold", "light-green", "dropdown-item", "p-0"], ["jhiTranslate", "sessionChat.button.resources", 1, "item-bold", "light-green", "dropdown-item", "p-0"], ["class", "dropdown-item p-0", 3, "ngClass", "click", 4, "ngIf"], [1, "vertical-line"], [3, "tooltipPosition"], ["class", "mr-2", 4, "ngIf"], [1, "mr-2"], [1, "btn", "btn-primary", "stop-button", 3, "click"], ["jhiTranslate", "sessionChat.coachSessionControl.stopCall"], ["endSessionModal", ""], ["resourcesForHelpModal", ""], ["askToShareOrganizationResources", ""], ["speakerDropdown", "ngbDropdown"], ["jhiTranslate", "sessionChat.coachSessionControl.selectSpeaker", 1, "item-bold"], ["ngbDropdownMenu", "", 1, "dropdown-menu", "dropdown-menu-speakers", "dropdown-menu-right"], [1, "item-light", "mb-2", 3, "click"], [1, "item-light", "d-flex", "justify-content-start", "align-items-top", 3, "click"], [3, "emoji"], ["virtualBackgroundDropdown", "ngbDropdown"], ["jhiTranslate", "sessionChat.paragraph.virtualBackgrounds", 1, "item-bold"], [1, "item-light", 3, "jhiTranslate"], [3, "virtualBackgroundSelected"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#script-light"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#script"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#panel-light"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#panel"], [1, "unread-indicator"], [1, "dropdown-item", "p-0", 3, "ngClass", "click"], ["jhiTranslate", "sessionChat.button.organizationResources", 1, "item-bold", "light-green", "dropdown-item", "p-0"], ["class", "btn btn-primary border-1", "id", "extend-session-btn", 3, "background", "click", 4, "ngIf"], ["id", "extend-session-btn", 1, "btn", "btn-primary", "border-1", 3, "click"], ["jhiTranslate", "sessionChat.button.extendSession"], [1, "btn", "btn-secondary", "border-1", 3, "disabled", "click"], ["jhiTranslate", "sessionChat.button.end"], ["class", "olha-theme", 4, "ngIf"], [1, "olha-theme"], [1, "d-flex", "justify-content-end"], ["icon", "times-circle", 1, "mt-3", "mr-3", 2, "cursor", "pointer", 3, "click"], [1, "modal-body", "text-center"], ["jhiTranslate", "sessionChat.header.confirm"], ["jhiTranslate", "sessionChat.paragraph.end"], [1, "d-flex", "justify-content-center", "mt-4"], ["type", "button", "jhiTranslate", "sessionChat.button.end", 1, "btn", "btn-primary", "m-2", 3, "click"], ["type", "button", "jhiTranslate", "sessionChat.button.close", 1, "btn", "btn-secondary", "m-2", 3, "click"], [1, "olha-theme", "resources-content"], ["icon", "times-circle", 1, "mt-3", 2, "cursor", "pointer", 3, "click"], [1, "modal-body", "pt-0"], [3, "user", "resourceSelected"], [1, "olha-theme", "p-2", "pb-3"], [1, "modal-body", "text-center", "p-0"], ["jhiTranslate", "sessionChat.header.notShared"], ["jhiTranslate", "sessionChat.paragraph.askToShare"], ["type", "button", "jhiTranslate", "sessionChat.button.cancel", 1, "btn", "btn-secondary", "m-2", 3, "click"], ["type", "button", "jhiTranslate", "sessionChat.button.askToSee", 1, "btn", "btn-primary", "m-2", 3, "click"]], template: function CoachSessionControlComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "nav", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelement(3, "span", 3);
        i0.ɵɵelement(4, "span", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 1);
        i0.ɵɵelementStart(6, "div");
        i0.ɵɵelementStart(7, "span", 5);
        i0.ɵɵelementStart(8, "a", 6);
        i0.ɵɵelementStart(9, "div", 7);
        i0.ɵɵlistener("mouseover", function CoachSessionControlComponent_Template_div_mouseover_9_listener() { return ctx.hover = true; })("mouseleave", function CoachSessionControlComponent_Template_div_mouseleave_9_listener() { return ctx.hover = false; })("click", function CoachSessionControlComponent_Template_div_click_9_listener() { return ctx.isSettingsOn = !ctx.isSettingsOn; });
        i0.ɵɵpipe(10, "translate");
        i0.ɵɵelementStart(11, "div", 8);
        i0.ɵɵelementStart(12, "div");
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(13, "svg", 9);
        i0.ɵɵelement(14, "use", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(15, "ul", 11, 12);
        i0.ɵɵtemplate(17, CoachSessionControlComponent_li_17_Template, 16, 4, "li", 13);
        i0.ɵɵelementStart(18, "li");
        i0.ɵɵelementStart(19, "div", 14);
        i0.ɵɵelementStart(20, "span", 15, 16);
        i0.ɵɵelementStart(22, "a", 6);
        i0.ɵɵelementStart(23, "div", 17);
        i0.ɵɵelement(24, "span", 18);
        i0.ɵɵelementStart(25, "div", 14);
        i0.ɵɵelementStart(26, "div", 19);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(27, "svg", 20);
        i0.ɵɵelement(28, "use", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(29, "span", 22);
        i0.ɵɵtext(30);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(31, "fa-icon", 23);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "ul", 24);
        i0.ɵɵtemplate(33, CoachSessionControlComponent_li_33_Template, 2, 1, "li", 25);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(34, "li");
        i0.ɵɵelementStart(35, "div");
        i0.ɵɵelementStart(36, "span", 15, 26);
        i0.ɵɵelementStart(38, "a", 6);
        i0.ɵɵelementStart(39, "div", 17);
        i0.ɵɵelement(40, "span", 27);
        i0.ɵɵelementStart(41, "div", 14);
        i0.ɵɵelementStart(42, "div", 19);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(43, "svg", 20);
        i0.ɵɵelement(44, "use", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(45, "span", 22);
        i0.ɵɵtext(46);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(47, "fa-icon", 23);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(48, "ul", 24);
        i0.ɵɵtemplate(49, CoachSessionControlComponent_li_49_Template, 2, 1, "li", 25);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(50, "li");
        i0.ɵɵelementStart(51, "div");
        i0.ɵɵelementStart(52, "span", 15, 28);
        i0.ɵɵelementStart(54, "a", 6);
        i0.ɵɵelementStart(55, "div", 17);
        i0.ɵɵelement(56, "span", 29);
        i0.ɵɵelementStart(57, "div", 14);
        i0.ɵɵelementStart(58, "div", 19);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(59, "svg", 20);
        i0.ɵɵelement(60, "use", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(61, "span", 22);
        i0.ɵɵtext(62);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(63, "fa-icon", 23);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(64, "ul", 24);
        i0.ɵɵtemplate(65, CoachSessionControlComponent_li_65_Template, 5, 4, "li", 30);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(66, CoachSessionControlComponent_li_66_Template, 16, 3, "li", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(67, "div", 31);
        i0.ɵɵlistener("click", function CoachSessionControlComponent_Template_div_click_67_listener() { return ctx.toggleScript(); })("mouseover", function CoachSessionControlComponent_Template_div_mouseover_67_listener() { return ctx.hover = true; })("mouseleave", function CoachSessionControlComponent_Template_div_mouseleave_67_listener() { return ctx.hover = false; });
        i0.ɵɵpipe(68, "translate");
        i0.ɵɵelementStart(69, "div", 8);
        i0.ɵɵelementStart(70, "div");
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(71, "svg", 9);
        i0.ɵɵtemplate(72, CoachSessionControlComponent__svg_use_72_Template, 1, 0, "use", 32);
        i0.ɵɵtemplate(73, CoachSessionControlComponent__svg_use_73_Template, 1, 0, "use", 33);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(74, "div", 31);
        i0.ɵɵlistener("click", function CoachSessionControlComponent_Template_div_click_74_listener() { return ctx.toggleUserPanel(); })("mouseover", function CoachSessionControlComponent_Template_div_mouseover_74_listener() { return ctx.hover = true; })("mouseleave", function CoachSessionControlComponent_Template_div_mouseleave_74_listener() { return ctx.hover = false; });
        i0.ɵɵpipe(75, "translate");
        i0.ɵɵelementStart(76, "div", 34);
        i0.ɵɵelementStart(77, "div");
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(78, "svg", 9);
        i0.ɵɵtemplate(79, CoachSessionControlComponent__svg_use_79_Template, 1, 0, "use", 35);
        i0.ɵɵtemplate(80, CoachSessionControlComponent__svg_use_80_Template, 1, 0, "use", 36);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(81, CoachSessionControlComponent_div_81_Template, 1, 0, "div", 37);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(82, "div", 38);
        i0.ɵɵelementStart(83, "span", 5);
        i0.ɵɵelementStart(84, "a", 6);
        i0.ɵɵelementStart(85, "div", 38);
        i0.ɵɵelement(86, "fa-icon", 39);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(87, "ul", 40);
        i0.ɵɵelementStart(88, "li", 41);
        i0.ɵɵlistener("click", function CoachSessionControlComponent_Template_li_click_88_listener() { return ctx.sendSelfScan(); });
        i0.ɵɵelement(89, "span", 42);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(90, "li", 41);
        i0.ɵɵlistener("click", function CoachSessionControlComponent_Template_li_click_90_listener() { return ctx.displayResourcesModal(); });
        i0.ɵɵelement(91, "span", 43);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(92, CoachSessionControlComponent_li_92_Template, 2, 3, "li", 44);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(93, "div", 45);
        i0.ɵɵelementStart(94, "div");
        i0.ɵɵelement(95, "audio-toggler", 46);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(96, "div");
        i0.ɵɵelement(97, "video-toggler", 46);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(98, CoachSessionControlComponent_div_98_Template, 2, 1, "div", 47);
        i0.ɵɵtemplate(99, CoachSessionControlComponent_div_99_Template, 3, 1, "div", 47);
        i0.ɵɵelementStart(100, "div", 48);
        i0.ɵɵelementStart(101, "button", 49);
        i0.ɵɵlistener("click", function CoachSessionControlComponent_Template_button_click_101_listener() { return ctx.stopCall(); });
        i0.ɵɵelement(102, "span", 50);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(103, CoachSessionControlComponent_ng_template_103_Template, 1, 1, "ng-template", null, 51, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(105, CoachSessionControlComponent_ng_template_105_Template, 5, 1, "ng-template", null, 52, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(107, CoachSessionControlComponent_ng_template_107_Template, 12, 0, "ng-template", null, 53, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(16);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(45, _c3, ctx.minutesLeft));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngStyle", ctx.hover ? i0.ɵɵpureFunction0(47, _c4) : i0.ɵɵpureFunction0(48, _c5))("matTooltipPosition", "below")("matTooltipClass", "feedback-tool-tip")("matTooltip", i0.ɵɵpipeBind1(10, 39, ctx.isSettingsOn ? "sessionChat.coachSessionControl.hideSettings" : "sessionChat.coachSessionControl.showSettings"));
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngIf", ctx.speakerList == null ? null : ctx.speakerList.length);
        i0.ɵɵadvance(13);
        i0.ɵɵtextInterpolate(ctx.selectedCamera == null ? null : ctx.selectedCamera.label);
        i0.ɵɵadvance(2);
        i0.ɵɵstyleProp("left", _r0.offsetWidth - 20 + "px");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.cameraList);
        i0.ɵɵadvance(13);
        i0.ɵɵtextInterpolate(ctx.selectedMicrophone == null ? null : ctx.selectedMicrophone.label);
        i0.ɵɵadvance(2);
        i0.ɵɵstyleProp("left", _r0.offsetWidth - 20 + "px");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.microphoneList);
        i0.ɵɵadvance(13);
        i0.ɵɵtextInterpolate(ctx.selectedLanguage == null ? null : ctx.selectedLanguage.name);
        i0.ɵɵadvance(2);
        i0.ɵɵstyleProp("left", _r0.offsetWidth - 20 + "px");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.languageList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.virtualBackgroundEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.isScriptOn ? "box-button-toggle-active" : "")("ngStyle", ctx.hover ? i0.ɵɵpureFunction0(49, _c4) : i0.ɵɵpureFunction0(50, _c5))("matTooltipPosition", "below")("matTooltipClass", "feedback-tool-tip")("matTooltip", i0.ɵɵpipeBind1(68, 41, ctx.isScriptOn ? "sessionChat.coachSessionControl.hideScript" : "sessionChat.coachSessionControl.showScript"));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.isScriptOn);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isScriptOn);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.isUserPanelOn ? "box-button-toggle-active" : "")("ngStyle", ctx.hover ? i0.ɵɵpureFunction0(51, _c4) : i0.ɵɵpureFunction0(52, _c5))("matTooltipPosition", "below")("matTooltipClass", "feedback-tool-tip")("matTooltip", i0.ɵɵpipeBind1(75, 43, ctx.isUserPanelOn ? "sessionChat.coachSessionControl.hideUserPanel" : "sessionChat.coachSessionControl.showUserPanel"));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.isUserPanelOn);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isUserPanelOn);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showUnreadIndicator);
        i0.ɵɵadvance(11);
        i0.ɵɵproperty("ngIf", ctx.areAnyOrganizationResourcesExistForUser);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("tooltipPosition", ctx.below);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("tooltipPosition", ctx.below);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.session != null && ctx.session.started);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.session != null && ctx.session.started);
    } }, directives: [i5.NgbNavbar, i15.JhiTranslateDirective, i5.NgbDropdown, i5.NgbDropdownToggle, i16.NgStyle, i17.MatTooltip, i5.NgbDropdownMenu, i16.NgIf, i18.FaIconComponent, i16.NgForOf, i16.NgClass, i19.AudioTogglerComponent, i20.VideoTogglerComponent, i21.EmojiComponent, i22.VirtualBackgroundSelectorComponent, i23.ResourcesForHelpComponent], pipes: [i6.TranslatePipe, i24.FindFlagCodeFromKeyPipe], styles: [".navbar[_ngcontent-%COMP%]{background:#f7eed2;padding-left:20px !important;padding-right:20px !important}.time-left[_ngcontent-%COMP%]{font-family:Poppins,sans-serif}.minutes[_ngcontent-%COMP%]{font-family:Poppins,sans-serif;font-weight:600;color:#44a38b}.box-button[_ngcontent-%COMP%]{font-family:Poppins,sans-serif;font-weight:400;width:80px;height:50px;color:#44a38b;background:#f7eed2;border-radius:8px;flex-direction:column;cursor:pointer}.box-button-toggle[_ngcontent-%COMP%]:active, .box-button-dropdown[_ngcontent-%COMP%]:hover, .box-button-toggle-active[_ngcontent-%COMP%]{color:#f7eed2;background:#44a38b}h3[_ngcontent-%COMP%]{margin-bottom:0}h5[_ngcontent-%COMP%]{margin-bottom:0}.dropdown-menu[_ngcontent-%COMP%]{padding:15px 25px;box-shadow:0 10px 20px rgba(0,0,0,.13);border-radius:10px;border:none}.dropdown-menu-settings[_ngcontent-%COMP%], .dropdown-menu-speakers[_ngcontent-%COMP%], .dropdown-menu-camera[_ngcontent-%COMP%], .dropdown-menu-3dots[_ngcontent-%COMP%]{min-width:-moz-fit-content;min-width:fit-content}.dropdown-menu-location-primary[_ngcontent-%COMP%]{top:65px !important;right:5px !important}.dropdown-toggle[_ngcontent-%COMP%]:after{display:none !important}.dropdown-item-disabled[_ngcontent-%COMP%]{background-color:#fff;color:#7cbfae !important;font-weight:bold}.dropdown-item[_ngcontent-%COMP%]:hover, .dropdown-item-disabled[_ngcontent-%COMP%]:hover{background-color:#fff;color:#0a4a3a;text-decoration:underline}a[_ngcontent-%COMP%]{text-decoration:none}.item-bold[_ngcontent-%COMP%]{margin-bottom:15px;font-family:\"Poppins\",serif;font-style:normal;font-weight:700;font-size:14px;line-height:25px;color:#0a4a3a;cursor:pointer}.item-light[_ngcontent-%COMP%]{margin-left:10px;font-family:\"Poppins\",serif;font-style:normal;font-weight:400;font-size:14px;line-height:20px;color:#44a38b;cursor:pointer;white-space:nowrap}.light-green[_ngcontent-%COMP%]{color:#44a38b !important}.stop-button[_ngcontent-%COMP%]{background:var(--accent-2) !important}.vertical-line[_ngcontent-%COMP%]{width:44px;height:2px;border:1px solid #44a38b;transform:rotate(90deg)}.unread-indicator[_ngcontent-%COMP%]{background-color:var(--accent-2) !important;position:absolute;border-radius:50%;height:8px;width:8px;top:-2px;right:-3px}[_nghost-%COMP%]  .feedback-tool-tip{color:#fff !important;background:#44a38b !important;font-size:14px !important}[_nghost-%COMP%]  .feedback-tool-tip:before{content:\"\";position:absolute;left:calc(50% - 10px) !important;z-index:10000}"] });
